import { render, staticRenderFns } from "./ArticleInfoSummary.vue?vue&type=template&id=53b5c77e&scoped=true&"
import script from "./ArticleInfoSummary.vue?vue&type=script&lang=ts&"
export * from "./ArticleInfoSummary.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleInfoSummary.vue?vue&type=style&index=0&id=53b5c77e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b5c77e",
  null
  
)

export default component.exports